/* Judge.me hydration helper for the one-page invisible wire page. Claude, 23 Aug 2026.

   Judge.me's widget script only hydrates markup present inside a `.jdgm-widget`
   wrapper at its own init pass. Our widget comes from the `judgeme.widget`
   metafield and, on a shade switch, is injected long afterwards — so without
   this it renders with blank timestamps, a hidden rating histogram, dead
   pagination and, most visibly, customer photos that never load, because
   Judge.me lazy-loads them from `data-src`.

   jdgm.initializeWidgets() handles timestamps and pagination; the rest we do
   ourselves so it cannot silently regress. A MutationObserver repeats the pass
   for reviews pulled in by pagination and for whole-widget swaps. */
(function () {
  'use strict';

  function mount() { return document.getElementById('iw-jm-mount'); }

  function paint(root) {
    if (!root) return;
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
    });
    root.querySelectorAll('.jdgm--loading').forEach(function (n) { n.classList.remove('jdgm--loading'); });
    root.querySelectorAll('.jdgm-temp-hidden').forEach(function (n) { n.classList.remove('jdgm-temp-hidden'); });
    root.querySelectorAll('.jdgm-temp-hiding-style').forEach(function (n) { n.remove(); });
    root.querySelectorAll('.jdgm-rev-widg').forEach(function (n) { n.style.display = 'block'; });
  }

  function hydrate() {
    var m = mount();
    if (!m) return;
    try { if (window.jdgm && window.jdgm.initializeWidgets) window.jdgm.initializeWidgets(); } catch (e) {}
    paint(m);
    /* Judge.me finishes its own pass a beat later; repaint over the top of it */
    setTimeout(function () { paint(m); }, 600);
    setTimeout(function () { paint(m); }, 1800);
  }

  window.iwHydrateReviews = hydrate;

  function containsWidget(node) {
    if (!node || node.nodeType !== 1) return false;
    return node.classList.contains('jdgm-rev-widg') || !!node.querySelector('.jdgm-rev-widg');
  }

  function watch() {
    var m = mount();
    if (!m) return;
    hydrate();
    if (!('MutationObserver' in window)) return;

    var busy = false;
    new MutationObserver(function (records) {
      if (busy) return;                       /* our own paint() mutates too */
      busy = true;
      /* a whole new widget (shade switch) needs Judge.me's own init again;
         reviews appended by pagination only need the lazy images finishing */
      var full = records.some(function (rec) {
        return [].some.call(rec.addedNodes, containsWidget);
      });
      setTimeout(function () {
        if (full) hydrate(); else paint(mount());
        busy = false;
      }, 120);
    }).observe(m, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
